import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-070589fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-upload" }
const _hoisted_2 = { class: "file-list" }
const _hoisted_3 = { class: "file-list__item__icon" }
const _hoisted_4 = ["href", "title"]
const _hoisted_5 = { class: "file-list__item__action" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "附件上传", -1))
const _hoisted_7 = { class: "text-grey ml15" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 删除 ")

export function render(_ctx, _cache) {
  const _component_ant_icon = _resolveComponent("ant-icon")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_upload = _resolveComponent("a-upload")
  const _component_hmd_table_action = _resolveComponent("hmd-table-action")
  const _component_file_status = _resolveComponent("file-status")
  const _component_hmd_empty_link = _resolveComponent("hmd-empty-link")
  const _component_a_table = _resolveComponent("a-table")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, { onClick: _ctx.showModal }, {
      default: _withCtx(() => [
        _createVNode(_component_ant_icon, { type: "UploadOutlined" }),
        _createElementVNode("span", null, _toDisplayString(_ctx.uploadButtonText), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.uuid,
          class: "file-list__item"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ant_icon, { type: "PaperClipOutlined" })
          ]),
          _createElementVNode("a", {
            href: item.url,
            title: item.name,
            target: "_blank"
          }, [
            _createElementVNode("span", null, _toDisplayString(item.name), 1)
          ], 8, _hoisted_4),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ant_icon, { type: "DeleteOutlined" })
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[0] || (_cache[0] = $event => ((_ctx.visible) = $event)),
      centered: true,
      "confirm-loading": _ctx.uploading,
      keyboard: false,
      "mask-closable": false,
      width: "960px",
      onCancel: _ctx.closeModal,
      zIndex: 1100,
      onOk: _ctx.ok
    }, {
      title: _withCtx(() => [
        _hoisted_6,
        _createElementVNode("small", null, "附件上限" + _toDisplayString(_ctx.maxCount) + "个，单个文件不得超过" + _toDisplayString(_ctx.maxSize) + "M", 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_hmd_table_action, { class: "pt0" }, {
          left: _withCtx(() => [
            _createVNode(_component_a_upload, {
              "before-upload": _ctx.beforeUpload,
              "custom-request": _ctx.customRequest,
              multiple: true,
              "show-upload-list": false,
              name: "file"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  disabled: _ctx.disabled,
                  loading: _ctx.uploading,
                  type: "primary"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.uploadButtonText), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"]),
                _createElementVNode("span", _hoisted_7, "（已选择" + _toDisplayString(_ctx.fileList.length) + "个文件）", 1)
              ]),
              _: 1
            }, 8, ["before-upload", "custom-request"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_table, {
          bordered: true,
          columns: _ctx.columns,
          "data-source": _ctx.fileList,
          pagination: false,
          scroll: { x: true },
          "row-key": "uid"
        }, {
          size: _withCtx(({ record }) => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$filters.humanizeFileSize(record.size)), 1)
          ]),
          status: _withCtx(({ record }) => [
            _createVNode(_component_file_status, {
              status: record.status
            }, null, 8, ["status"])
          ]),
          action: _withCtx(({ record }) => [
            (['SUCCESS','FAIL'].includes(record.status))
              ? (_openBlock(), _createBlock(_component_hmd_empty_link, {
                  key: 0,
                  onClick: $event => (_ctx.deleteFile(record))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source"])
      ]),
      _: 1
    }, 8, ["visible", "confirm-loading", "onCancel", "onOk"])
  ]))
}